<template>
    <card v-if="items.length!==0">
        <template v-slot:header>Konferenzräume Anfragen</template>

        <loading v-show="loading"></loading>

        <div v-show="!loading">
            <p v-show="items.length === 0">Keine Anfragen.</p>

            <tailwind-table v-show="items.length > 0" :header="['Konferenzraum', 'Bucher', 'Datum', '']">
                <tr v-for="item in items">
                    <td class="px-6 py-3">{{ item.conference_room.name }}</td>
                    <td class="px-6 py-3">{{ item.user.name }}</td>
                    <td class="px-6 py-3">{{ item.start | dayOfWeek }} - {{ item.start | date }} {{ item.start | time }} - {{ item.end | time }} Uhr</td>
                    <td>
                        <button-white><a :href="'/admin/pages/conference_rooms/#room' + item.conference_room.id">Buchung aufrufen</a></button-white>
                    </td>
                </tr>
            </tailwind-table>
        </div>
    </card>
</template>

<script>
import Card from "./UI/Card";
import Loading from "./UI/Loading";
import TailwindTable from "./UI/TailwindTable";
import ConfirmDialog from "./UI/ConfirmDialog";
import ButtonWhite from "./UI/ButtonWhite";

export default {
    name: "ConferenceRoomRequests",
    components: {ButtonWhite, ConfirmDialog, TailwindTable, Loading, Card},

    data: () => ({
        items: [],
        loading: true,
    }),

    mounted() {
        this.load();
    },

    methods: {
        load() {
            this.loading = true;
            window.axios.get('/admin/conference_room_bookings/requests').then(response => {
                this.items = response.data.data;
                this.loading = false;
            })
        },
    },

    filters: {
        time(val) {
            return val.substr(11, 5);
        },
        date(val) {
            let [y, m, d] = val.substr(0, 10).split('-');
            return `${d}.${m}.${y}`;
        },
        dayOfWeek(val) {
            let [y, m, d] = val.substring(0, 10).split('-');
            return new Date(`${y}-${m}-${d}`).toLocaleString('de-de', {  weekday: 'short' });
        }
    },
}
</script>

<style scoped>

</style>
